export default {
  token: state => {
    return state.token
  },
  userInfo: state => {
    return state.userInfo
  },
  jssdkEnabled: state => {
    return state.jssdkEnabled
  },
  address: state => {
    return state.address
  },
  location: state => {
    return state.location
  },
  qrcode: state => {
    return state.qrcode
  },
  shopOpenId: state => {
    return state.shopOpenId
  },
  subscribe: state => {
    return state.subscribe
  },
  shopSubscribe: state => {
    return state.shopSubscribe
  }
}



// WEBPACK FOOTER //
// ./src/store/getters.js